<template>
  <div class="step-missing-balance step-stagger">
    <div class="hero-badge">
      <img class="hero-badge-star" :src="stars.greenLarge" alt="" />
      <img class="hero-badge-icon" :src="icons.assuredWorkload" alt="" />
    </div>

    <h1 class="step-heading" dir="auto">המשכנתא חוברה בהצלחה!</h1>
    <p class="step-subtitle" dir="auto">
      אנחנו כמעט שם. שלב אחרון לפני הצעת<br />החסכון - נצטרך גישה לקריאה בלבד של<br />חשבון העו״ש שלך.
    </p>

    <div class="info-callout">
      <div class="info-callout-badge">
        <img class="info-callout-icon" :src="icons.lightbulb" alt="" />
      </div>
      <h3 class="info-callout-title" dir="auto">
        למה צריך לקרוא את העו״ש כדי<br />לחשב חיסכון?
      </h3>
      <p class="info-callout-text" dir="auto">
        האלגוריתם של רייזאפ מבין בעזרת ניתוח העו״ש כמה גבוה כדאי שההחזר החודשי שלך יהיה. בלעדיו, לא נוכל המלצת חסכון מדויקת.
      </p>
    </div>

    <div class="cta-area">
      <CtaButton text="קדימה" @click="$emit('next')" />
    </div>
  </div>
</template>

<script>
import CtaButton from './CtaButton.vue';

/* eslint-disable global-require */
const icons = {
  assuredWorkload: require('../assets/lucide-assured-workload.svg'),
  lightbulb: require('../assets/lucide-lightbulb.svg'),
};
const stars = {
  greenLarge: require('../assets/star-union-green.svg'),
};
/* eslint-enable global-require */

export default {
  name: 'StepMissingBalance',
  components: { CtaButton },
  data() {
    return { icons, stars };
  },
};
</script>

<style lang="scss" scoped>
.step-missing-balance {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 27px;
}

.hero-badge {
  position: relative;
  width: 70px;
  height: 70px;
  margin: 16px auto 24px;
}

.hero-badge-star {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.hero-badge-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
  display: block;
  // The assured_workload icon is filled white in Figma; the green star is
  // behind it, so force white regardless of the file's fallback fill.
  filter: brightness(0) invert(1);
}

.step-heading {
  font-family: 'SimplerProAlte', sans-serif;
  font-size: 32px;
  line-height: 36px;
  font-weight: 900;
  font-style: normal;
  font-synthesis: none;
  color: #205441;
  text-align: center;
  margin: 0 auto 20px;
  max-width: 300px;

  @media (max-width: 500px) {
    font-size: 26px;
    line-height: 32px;
    margin-bottom: 16px;
  }
}

.step-subtitle {
  font-family: 'SimplerPro', sans-serif;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #205441;
  text-align: center;
  margin: 0 auto 36px;
  max-width: 320px;

  @media (max-width: 500px) {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 28px;
  }
}

.info-callout {
  background: #dce8f6;
  border-radius: 20px;
  padding: 26px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // 4px wider on each side than the body copy above.
  margin-left: -4px;
  margin-right: -4px;
}

.info-callout-badge {
  width: 30px;
  height: 30px;
  background: #4868ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.info-callout-icon {
  width: 18px;
  height: 18px;
  display: block;
}

.info-callout-title {
  font-family: 'SimplerPro', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #202125;
  text-align: center;
  margin: 0 0 10px;
}

.info-callout-text {
  font-family: 'SimplerPro', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #202125;
  text-align: center;
  margin: 0;
  // Prevent the last line from being a single dangling word. `balance`
  // spreads content evenly across all lines; `pretty` only tweaks the
  // last few lines — we chose balance because Chrome's `pretty`
  // implementation still left an orphan here.
  text-wrap: balance;
}

.cta-area {
  margin-top: auto;
  padding-top: 28px;
  padding-bottom: 24px;
}
</style>
